import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "key-stroke-hints" }
const _hoisted_2 = ["onMouseover", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.query.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onMouseleave: _cache[1] || (_cache[1] = $event => ($setup.highlighted_ideograph = null)),
          class: "ideograph-toolbar"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ideographs.split(''), (d) => {
            return (_openBlock(), _createElementBlock("a", {
              key: d,
              href: "#",
              class: _normalizeClass({
          'selected-ideograph':
            d === $setup.highlighted_ideograph || d === $setup.selected_ideograph,
        }),
              onMouseover: $event => ($setup.highlighted_ideograph = d),
              onClick: _withModifiers($event => ($setup.selected_ideograph = d), ["prevent"])
            }, _toDisplayString(d), 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */, _hoisted_2))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($setup.selected_ideograph = null), ["prevent"])),
            href: "#"
          }, "X")
        ], 32 /* NEED_HYDRATION */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("table", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries($setup.filtered_by_ideograph), ([suffix, characters]) => {
        return (_openBlock(), _createElementBlock("tr", null, [
          _createElementVNode("td", null, [
            _createVNode($setup["KeyStroke"]),
            _createTextVNode(_toDisplayString(suffix
              .split("")
              .map((item) => {
                return $setup.decodeKeyStroke(item);
              })
              .join("")), 1 /* TEXT */)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(characters, (ch) => {
            return (_openBlock(), _createElementBlock("td", {
              class: _normalizeClass({
            'selected-ideograph': $setup.ideograph[ch] === $setup.highlighted_ideograph,
          })
            }, _toDisplayString(ch) + " " + _toDisplayString($setup.selected_ideograph === null ? "" : $setup.selected_ideograph), 3 /* TEXT, CLASS */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}